module.exports = __webpack_public_path__ + "1.0/img/bisai-banner.db3a0d76.png";